import classnames from 'classnames'
import React, { ChangeEventHandler, FocusEventHandler, ReactNode } from 'react'

import { useLang } from '@/hooks/useLang'
import { useWorkaround } from '@/hooks/useWorkaround'

interface ISelectProps {
  id: string
  title: string
  value: string | number
  children: ReactNode
  onChange?: ChangeEventHandler<HTMLSelectElement>
  isDisabled?: boolean
  isSelectWithHalf?: boolean
  isHideCurrency?: boolean
  onFocus?: FocusEventHandler<HTMLSelectElement>
}

export const Select = (props: ISelectProps) => {
  const { isID } = useLang()
  const { restoreScrollOffset } = useWorkaround()
  const selectClassName = classnames('ipt-box__select', {
    'ipt-box--currency': props.isHideCurrency ? false : !isID,
    'ipt-box__select--inactive': props.isDisabled,
    'ipt-box__select--with-half': props.isSelectWithHalf,
  })

  return (
    <>
      <label htmlFor={props.id} className="ipt-box__lb">
        {props.title}
      </label>
      <span className={selectClassName}>
        <select
          id={props.id}
          value={props.value}
          onChange={props.onChange}
          onBlur={restoreScrollOffset}
          onFocus={props.onFocus}
          disabled={props.isDisabled}
        >
          {props.children}
        </select>
      </span>
    </>
  )
}
